import React, { useEffect, useState } from 'react'
import { has } from 'lodash'
import { connect } from 'react-redux'

import {
  GET_CAPTCHA,
  SET_HEADER_TYPE,
  SET_PAGE_BANNER,
  SHOW_INFO_MESSAGE,
  SUBMIT_CONTACT_FORM
} from '@/store/constants/actionTypes'
import Icon from '@/@core/components/icon'
import Meta from '@/components/common/Meta'
import { META_CONTENTS } from '@/v1/constants/seo'
import PageLoader from '@/components/common/PageLoader'
import Promotion from '@/components/sections/Promotion'
import ContactUsBanner from '@/components/banners/ContactUsBanner'
import { assets, onlyNumberAllow, onlyValidChar } from '@/helpers/common'
import { ContactSrOnly } from '@/v1/sr-only'

function ContactUs(props) {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    address: '',
    message: '',
    captcha: ''
  })
  const [formError, setFormError] = useState({})

  useEffect(() => {
    props.onGetCaptcha(Math.random().toString(36).slice(-5))
  }, [])

  useEffect(() => {
    setFormError({
      ...formError,
      ...props.GR.contactError.errors
    })

    if (props.GR.contactError) {
      props.onGetCaptcha(Math.random().toString(36).slice(-5))
    }

    setFormData({
      ...formData,
      captcha: ''
    })
  }, [props.GR.contactError])

  useEffect(() => {
    if (has(props.GR.contactError.errors, 'captcha')) {
      props.onShowInfoMessage({ type: 'error', text: props.GR.contactError.errors.captcha[0] })
    }
  }, [props.GR.contactError])

  useEffect(() => {
    if (has(props.GR.contactSuccess, 'message')) {
      props.onShowInfoMessage({ type: 'success', text: props.GR.contactSuccess.message })
      setFormData({
        name: '',
        email: '',
        phone: '',
        address: '',
        message: '',
        captcha: ''
      })
      props.onGetCaptcha(Math.random().toString(36).slice(-5))
    }
  }, [props.GR.contactSuccess])

  const changeCaptcha = event => {
    event.preventDefault()

    props.onGetCaptcha(Math.random().toString(36).slice(-5))

    setFormData({
      ...formData,
      captcha: ''
    })
  }

  const inputOnChangeHandler = e => {
    let name = e.target.name
    let value = e.target.value
    setFormData({
      ...formData,
      [name]: value
    })
    formValidation(name)
  }

  const checkPhoneMaxLengthError = event => {
    let errors = {}
    if (String(event.target.value).length > 14) {
      errors.phone = ['Phone number max length 15 digits']
      setFormError({
        ...formError,
        ...errors
      })
    }

    return onlyNumberAllow(event, 14)
  }

  const formValidation = (nameOfField = '') => {
    setFormError({})
    let errors = {}
    let data = formData

    let spPattern = /[-!$%^&*()_+|~=`{}\[\]:\/;<>?,.@#]/
    let emailPattern =
      /^(([^<>#$%=+()[\]\\.,;:\s*!`~@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/

    if (!data?.name && ['name', ''].includes(nameOfField)) {
      errors.name = ['Name is required']
    } else if (spPattern.test(data.name) && ['name', ''].includes(nameOfField)) {
      errors.name = ['Invalid name format']
    }

    if (!data?.email && ['email', ''].includes(nameOfField)) {
      errors.email = ['Email is required']
    } else if (emailPattern.test(data.email) === false && ['email', ''].includes(nameOfField)) {
      errors.email = ['Invalid email format']
    }

    if (!data?.phone && ['phone', ''].includes(nameOfField)) {
      errors.phone = ['Phone is required']
    }

    if (!data.address && ['address', ''].includes(nameOfField)) {
      errors.address = ['Address is required']
    }

    if (!data.message && ['message', ''].includes(nameOfField)) {
      errors.message = ['Message is required']
    }

    if (!data.captcha && ['captcha', ''].includes(nameOfField)) {
      errors.captcha = ['Captcha is required']
    } else if (spPattern.test(data.captcha) && ['captcha', ''].includes(nameOfField)) {
      errors.captcha = ['Invalid captcha format']
    }

    if (Object.keys(errors).length > 0) {
      setFormError({
        ...errors
      })
    } else {
      return true
    }

    return false
  }

  const onSubmitHandler = async e => {
    e.preventDefault()
    let validate = formValidation()
    if (validate === true) {
      await props.onSubmitContactForm({
        ...formData,
        key: props.GR.captchaData.key
      })
    }
  }

  const captchaImage = props.GR.captchaData ? props.GR.captchaData.img : ''

  const GR = {
    captchaImage,
    changeCaptcha,
    contactLoading: false
  }

  return (
    <>
      <Meta
        title={META_CONTENTS.contact.title}
        keywords={META_CONTENTS.contact.keywords}
        description={META_CONTENTS.contact.description}
      />
      <ContactSrOnly />

      <ContactUsBanner />

      <section className='mobile-banner-content-section lg-mn:hidden section-spacing--small'>
        <div className='container mx-auto'>
          <div className='row sm-mx:flex-col-reverse'>
            <div className='w-full text-center'>
              <div className='banner-content text-center'>
                <h2 className='text-4xl2 font-bold text-secondary mb-4 md-mx:text-xl md-mx:mb-1'>
                  Searching For Full Customizable Storage and
                  <br className='sm-mx:hidden' /> Shipping Solution?
                </h2>
                <h3 className='text-2xl font-normal text-gray-400 mb-1 md-mx:text-sm15'>
                  Our Dedicated Storage Expert’s Team Are Waiting To Hear From You!
                </h3>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className='contact-form-section section-spacing'>
        <div className='container'>
          <div className='row justify-around'>
            <div className='w-full'>
              <div className='contact-form-warp row md-mx:flex-col-reverse'>
                <div className='left-side w-8/12 md-mx:w-full relative pb-10'>
                  <h2 className='title'>Get In Touch</h2>
                  <form className='contact-form w-full' onSubmit={onSubmitHandler}>
                    <div className='row mb-6'>
                      <div className='w-6/12 pr-2  md-mx:w-full sm-mx:pr-0 md-mx:mb-6'>
                        <div className={formError?.name ? 'input-group has-error' : 'input-group'}>
                          <input
                            type='text'
                            placeholder='Name'
                            name='name'
                            value={formData.name}
                            autoComplete='off'
                            onChange={e => inputOnChangeHandler(e)}
                          />
                          {formError?.name ? <span className='error'>{formError.name}</span> : ''}
                        </div>
                      </div>
                      <div className='w-6/12 pl-2  md-mx:w-full md-mx:pl-0'>
                        <div className={formError?.email ? 'input-group has-error' : 'input-group'}>
                          <input
                            type='text'
                            placeholder='Email'
                            name='email'
                            value={formData.email}
                            autoComplete='off'
                            onChange={e => inputOnChangeHandler(e)}
                          />
                          {formError?.email ? <span className='error'>{formError.email}</span> : ''}
                        </div>
                      </div>
                    </div>
                    <div className='row mb-6'>
                      <div className='w-6/12 pr-2  md-mx:w-full md-mx:pr-0 md-mx:mb-6'>
                        <div className={formError?.phone ? 'input-group has-error' : 'input-group'}>
                          <input
                            type='text'
                            placeholder='Phone'
                            name='phone'
                            value={formData.phone}
                            onKeyDown={e => checkPhoneMaxLengthError(e)}
                            autoComplete='off'
                            onChange={e => inputOnChangeHandler(e)}
                          />
                          {formError?.phone ? <span className='error'>{formError.phone}</span> : ''}
                        </div>
                      </div>
                      <div className='w-6/12 pl-2  md-mx:w-full md-mx:pl-0'>
                        <div className={formError?.address ? 'input-group has-error' : 'input-group'}>
                          <input
                            type='text'
                            placeholder='Address'
                            name='address'
                            value={formData.address}
                            autoComplete='off'
                            onChange={e => inputOnChangeHandler(e)}
                          />
                          {formError?.address ? <span className='error'>{formError.address}</span> : ''}
                        </div>
                      </div>
                    </div>
                    <div className='row mb-6'>
                      <div className='input-group w-full'>
                        <div className={formError?.message ? 'input-group has-error' : 'input-group'}>
                          <textarea
                            placeholder='Message'
                            name='message'
                            autoComplete='off'
                            onChange={e => inputOnChangeHandler(e)}
                            value={formData.message}
                          ></textarea>
                          {formError?.message ? <span className='error'>{formError.message}</span> : ''}
                        </div>
                      </div>
                    </div>
                    <div className='row mb-6'>
                      <div className='captcha-image w-3/12 sm-mx:w-4/12 pr-2'>
                        {!props.GR.captchaData ? <PageLoader /> : <img src={captchaImage} alt={'captcha'} />}
                      </div>
                      <div className='w-7/12 pl-2 sm-mx:w-6/12'>
                        <div className={formError?.captcha ? 'input-group has-error' : 'input-group'}>
                          <input
                            type='text'
                            placeholder='Captcha code'
                            name='captcha'
                            value={formData.captcha}
                            autoComplete='off'
                            onKeyDown={e => onlyValidChar(e, 4)}
                            onChange={e => inputOnChangeHandler(e)}
                          />
                        </div>
                      </div>
                      <div className='input-group w-2/12 pl-2'>
                        <button
                          type='button'
                          className='btn btn-primary change-captch-btn'
                          onClick={changeCaptcha}
                          disabled={GR.captchaLoading}
                        >
                          <Icon icon='uil:redo' fontSize={22} />
                        </button>
                      </div>
                    </div>
                    <div className='row'>
                      <div className='input-group w-full'>
                        <button className='btn btn-primary submit-btn'>Send Now</button>
                      </div>
                    </div>
                  </form>
                  {GR.contactLoading && (
                    <div className='loading'>
                      <img src={assets('images/loading.svg')} alt={''} />
                    </div>
                  )}
                </div>
                <div className='right-side w-4/12 md-mx:w-full'>
                  <h2 className='title'>Reach Us</h2>
                  <ul className='contact-info'>
                    <li className='address'>
                      <span className='info-title'>Office Address</span>
                      <address>
                        Ship And Storage
                        <br /> 228 East 45th Street, Ground Floor, New York, NY 10017
                      </address>
                    </li>
                    <li className='phone'>
                      <span className='info-title'>Phone/Email</span>
                      <address>
                        We Operate 24/7
                        <br /> Call <a href='tel:18889063909'>1 888 906 3909</a>
                        <br />
                        <a href='mailto:support@shipandstorage.com'>support@shipandstorage.com</a>
                      </address>
                    </li>
                    <li className='time'>
                      <span className='info-title'>Office Hour</span>
                      <address>
                        Monday – Friday, 9am – 6pm EST
                        <br /> Saturday and Sunday closed
                      </address>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Promotion />
    </>
  )
}

const mapStateToProps = state => {
  return {
    GR: state.globalReducer
  }
}
const mapDispatchToProps = dispatch => ({
  onSetBanner: banner => dispatch({ type: SET_PAGE_BANNER, data: banner }),
  onSetHeaderType: headerType => dispatch({ type: SET_HEADER_TYPE, data: headerType }),
  onGetCaptcha: data => dispatch({ type: GET_CAPTCHA, data }),
  onSubmitContactForm: data => dispatch({ type: SUBMIT_CONTACT_FORM, data }),
  onShowInfoMessage: options => dispatch({ type: SHOW_INFO_MESSAGE, options })
})
export default connect(mapStateToProps, mapDispatchToProps)(ContactUs)
